import { GrowthBook } from '@growthbook/growthbook-react'
import { StudioEnvSubDomain, getCurrentEnvironment } from './helpers'

type GbCredentialType = { apiHost: string; clientKey: string }

function getEnvCredentials(): GbCredentialType {
  const environment = getCurrentEnvironment()
  const envSubDomain = environment.split('.')[0] as StudioEnvSubDomain

  let apiHost = 'https://api-growthbook.us.skit.ai'
  let clientKey = ''

  switch (envSubDomain) {
    case 'us':
      clientKey = 'sdk-EPcGkvriXSPMtCME'
      break
    case 'us-sandbox':
      clientKey = 'sdk-eWUrRJPuVZ3DbuRJ'
      break
    default:
      clientKey = 'sdk-1HMhQLQa5GuPeXo'
  }

  return { apiHost, clientKey }
}

export const growthBookInstance = new GrowthBook({
  ...getEnvCredentials(),
  enableDevMode: true,
  subscribeToChanges: true,
})
